import React, { useEffect, useRef, useState } from "react";
import { Container, Form, InputGroup, Table } from "react-bootstrap";
import addicon from "../assets/images/addicon.svg";
import editAction from "../assets/images/editaction.svg";
import deleteAction from "../assets/images/deleteaction.svg";
import { useNavigate } from "react-router-dom";
import homeImage from "../assets/images/home.svg";
import { API_URL } from "../services/APIRoute";
import { commonservices, } from "../services/CommonServices";
import Loader, { LoaderType } from "./common-component/Loader";
import { useDispatch, useSelector } from "react-redux";
import Nodata from "./common-component/Nodata";
import DeleteModal from "../Modals/DeleteModal";
import { setSandboxWorkFlowGetListData, SandboxWorkFlowGetList } from "../services/ReduxTookit/Slice/SandboxWorkFlowRedux";
import searchicon from "../assets/images/searchicon.svg";
import useDebounce from "../hooks/useDebounce";

function Sandboxs() {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [modalShow, setModalShow] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const debouncingValue = useDebounce(searchValue, 500);
    const [roleAccess, setRoleAccess] = useState({});
    const [loading, setLoading] = useState(false);

    const [DeletePayload, setDeletePayload] = useState({
        workflowid: "",
        status: "",
    });
    let UserRoleRight = useSelector((state) => state.userinfo?.UserRoleRight);

    useEffect(() => {
        if (UserRoleRight) {
            setRoleAccess(commonservices?.GetRoleAccess("Workflow", UserRoleRight));
        }
    }, [UserRoleRight]);

    const [workflowList, setWorkflowList] = useState(null);

    function getWorkFlowList() {
        setLoading(true);
        let request = {
            searchText: debouncingValue,
        };
        dispatch(SandboxWorkFlowGetList(request));
    }

    useEffect(() => {
        getWorkFlowList();
        return () => {
            dispatch(setSandboxWorkFlowGetListData());
        };
    }, [debouncingValue]);

    const getWorkFlowGetListData = useSelector(
        (state) => state?.sandboxworkflowredux?.SandboxWorkFlowGetListData?.data
    );

    useEffect(() => {
        if (getWorkFlowGetListData && getWorkFlowGetListData?.isValidate) {
            setWorkflowList(getWorkFlowGetListData?.data?.data);
            setLoading(false);
        }
        if (getWorkFlowGetListData && !getWorkFlowGetListData?.isValidate) {
            setWorkflowList(null);
            setLoading(false);
        }
    }, [getWorkFlowGetListData]);

    return (
        <div className="projects-page-main all-page-top">
            <Container>
                <div className="top-bot-section workflow-tab">
                    <h6>
                        <div className="d-flex gap-2 align-items-center">
                            <div>
                                <img
                                    src={homeImage}
                                    alt="home"
                                    title="home"
                                    style={{ cursor: "pointer", marginBottom: "3px" }}
                                    onClick={() => navigate("/")}
                                />
                                <span style={{ fontWeight: "400", color: "#666666" }}>
                                    {" | "}
                                </span>
                                <span className="mt-1">
                                    Sandbox{" "}
                                    {workflowList?.length > 0 && `(${workflowList?.length})`}
                                </span>
                            </div>
                            <div className="header-search-input searchplaceholder">
                                <InputGroup>
                                    <InputGroup.Text id="basic-addon1">
                                        <img
                                            src={searchicon}
                                            alt="searchicon"
                                            className="cursor-pointer"
                                        />
                                    </InputGroup.Text>
                                    <Form.Control
                                        placeholder={`Search Sandbox Workflow`}
                                        aria-label="Search"
                                        aria-describedby="basic-addon1"
                                        value={searchValue}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                    </h6>
                    <div >

                    </div>
                    <div className="top-bot-right-section">
                        <div className="d-flex gap-2">
                            {roleAccess?.iscreate && (
                                <>
                                    <div
                                        className={"filtering-main"}
                                        id="add-project"
                                        onClick={(e) => {
                                            let data = commonservices.bodyEncryption(`0?v=0&r=wl`);
                                            navigate(`/sandbox/${data}`);
                                        }}
                                    >
                                        <img src={addicon} alt="filtericon" />
                                        <span>Add</span>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </Container>
            <div className="main-page-content">
                <Container>
                    <div className="common-table-main">
                        <div className="table-wrapper-main">
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th className="width250 sticky-workflow">
                                            Sandbox Workflow Name
                                        </th>
                                        <th className="text-end sticky-actions">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <Loader
                                            type={LoaderType.TableRow}
                                            count={6}
                                            nooftd={2}
                                        />
                                    ) : (
                                        <>
                                            {workflowList?.length > 0 ? (
                                                workflowList?.map((item) => {
                                                    return (
                                                        <tr key={item?.workflowsandboxid}>
                                                            <td
                                                                className="theme-color-text fw600 sticky-workflow"
                                                                title={item?.workflowname}
                                                            >
                                                                <span
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        let data = commonservices.bodyEncryption(
                                                                            `${item?.workflowsandboxid}?v=1&r=wl`,
                                                                        );
                                                                        navigate(`/sandbox/${data}`);
                                                                    }}
                                                                >
                                                                    {commonservices.truncateText(
                                                                        item?.workflowname,
                                                                        30,
                                                                    )}
                                                                </span>
                                                            </td>
                                                            <td className="sticky-actions">
                                                                <div className="all-actions">
                                                                    <span
                                                                        onClick={() => {
                                                                            let data =
                                                                                commonservices.bodyEncryption(
                                                                                    `${item?.workflowsandboxid}`,
                                                                                );
                                                                            navigate(`/sandbox/${data}`);
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={editAction}
                                                                            alt="editAction"
                                                                            title="Edit"
                                                                        />
                                                                    </span>

                                                                    <img
                                                                        src={deleteAction}
                                                                        alt="deleteAction"
                                                                        title="Delete"
                                                                        onClick={() => {
                                                                            setModalShow(true);
                                                                            setDeletePayload({
                                                                                id: item?.workflowsandboxid
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <></>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </Table>
                            {((workflowList && workflowList?.length === 0) ||
                                !workflowList) &&
                                !loading && (
                                    <>
                                        <Table>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <Nodata />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </>
                                )}
                        </div>
                    </div>
                </Container>
            </div>
            {modalShow && (
                <DeleteModal
                    payload={DeletePayload}
                    url={API_URL.SANDBOXWORKFLOW.DELETE}
                    show={modalShow}
                    bindlist={getWorkFlowList}
                    onHide={(e) => setModalShow(false)}
                />
            )}
        </div>
    );
}

export default Sandboxs;
